import {Card} from 'shells/card/card';
import {GridList} from 'shells/grid-list/grid-list';
import {ChartLineRegularIcon} from 'shells/icon/svg/chart-line-regular-icon';
import {TargetArrowIcon} from 'shells/icon/svg/target-arrow-icon';
import {ViewExploreIcon} from 'shells/icon/svg/view-explore-icon';
import {Stack} from 'shells/layout/stack/stack';

import type {GetChatbotReport_chatbotReport_aiMetrics as AiMetrics} from 'nutshell-graphql-types';

import {AiSectionHeader} from './ai-section-header';
import {AiSummary} from './ai-summary';
import {ChatbotReportTableEmptyState} from './chatbot-report-table-empty-state';

interface Props {
    aiMetrics: AiMetrics;
    dateRange: string;
}

export function AiSummarySection(props: Props) {
    return (
        <Card hasBorder={true} borderRadius={8} className='pad-24'>
            <Stack spacing={8}>
                <AiSectionHeader dateRange={props.dateRange} />
                {!props.aiMetrics.summary ? (
                    <ChatbotReportTableEmptyState text='Not enough data to generate a summary for this period' />
                ) : (
                    <GridList>
                        <AiSummary
                            key='performance'
                            title='Performance'
                            icon={ViewExploreIcon}
                            description={
                                props.aiMetrics.summary?.performance ??
                                'Not enough data to generate a performance summary for this period'
                            }
                        />
                        <AiSummary
                            key='activity'
                            title='Activity'
                            icon={ChartLineRegularIcon}
                            description={
                                props.aiMetrics.summary?.activity ??
                                'Not enough data to generate an activity summary for this period'
                            }
                        />
                        <AiSummary
                            key='impact'
                            title='Impact'
                            icon={TargetArrowIcon}
                            description={
                                props.aiMetrics.summary?.impact ??
                                'Not enough data to generate an impact summary for this period'
                            }
                        />
                    </GridList>
                )}
            </Stack>
        </Card>
    );
}
